import Service from "../Service";

const resource = "SleCampaignSalesOrder/";

export default {
  save(cmp, requestID) {
    return Service.post(resource + "save", cmp, {
      params: { requestID: requestID },
    });
  },

  list(parameters, requestID) {
    return Service.post(resource + "list", parameters, {
      params: { requestID: requestID },
    });
  },
};